module.exports = __webpack_public_path__ + "static/media/rtp.c88a99c1.webp";